module.exports = __webpack_public_path__ + "img/life-insurance-compare.868253a.png";